// extracted by mini-css-extract-plugin
module.exports = {"stickyBar":"get-pricing_stickyBar__zUpdv"};